// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  price_level_code: yup.string().label("Price level code").required(),
  price_level_name: yup.string().label("Price level name").required()
})